import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useJotpaRekisterointiSelector } from './store';
function getRedirectPath(state, validate) {
    for (const { schema, slice, redirectPath } of validate) {
        if (!schema.isValidSync(state[slice].form)) {
            return redirectPath;
        }
    }
}
export function JotpaWizardValidator({ validate, children }) {
    const state = useJotpaRekisterointiSelector((state) => state);
    const navigate = useNavigate();
    const redirect = getRedirectPath(state, validate);
    useEffect(() => {
        if (redirect) {
            navigate(redirect);
        }
    }, [navigate, redirect]);
    return _jsx(_Fragment, { children: children });
}
